import { useEffect } from 'react'
import { AdditionalBreakpointsEnum } from 'shared/constants/breakpoints'
import { UnifiedAgentContent } from 'pages/chatbot/ui/UnifiedAgent'
import { useChatbotLayoutContext } from 'pages/chatbot/context/chatbotLayoutContext'

export const ChatbotNewV2Page = () => {
  const chatbotLayoutStore = useChatbotLayoutContext()
  const { setCustomCollapseWidth } = chatbotLayoutStore.pageLayoutStore

  useEffect(() => {
    setCustomCollapseWidth(AdditionalBreakpointsEnum['1280'])
    return () => {
      setCustomCollapseWidth(null)
    }
  }, [])

  return <UnifiedAgentContent />
}
